import type { GeolocationFormValues } from './types';
import type { GeoLocationRead } from 'src/common/external/bambi-api/bambiApi';

export const defaultFormValues: GeolocationFormValues = {
  id: undefined,
  label: '',
  coordinates: undefined,
};

export const assignDefaultFormValues = (
  geolocation: GeoLocationRead | undefined
): GeolocationFormValues => {
  if (!geolocation) return defaultFormValues;

  return {
    id: geolocation.id,
    label: geolocation.label,
    coordinates: {
      latitude: geolocation.location.latitude,
      longitude: geolocation.location.longitude,
    },
  };
};
